<template>
  <el-config-provider :locale="locale">
    <div class="us_main">
      <div class="us_box">
        <span class="us_text">上海悦宝互联网金融信息服务股份有限公司（简称"悦宝金服"）成立于2016年4月，是上海悦高软件股份有限公司的全资子公司。作为专业的金融科技服务商，我们专注于证券交易软件开发和金融信息服务，致力于为投资者提供智能化的交易工具和专业的投资教育服务。</span>
        <span class="us_title1">我们的使命与愿景</span>
        <span class="us_title2">使命</span>
        <span class="us_text">我们相信，通过专业的辅助工具和系统的风险教育，每一位投资者都能够建立理性的投资观念和必要的风险意识。</span>
        <span class="us_title2">愿景</span>
        <span class="us_text">成为中国领先的投资教育科技服务商</span>
        <span class="us_text">我们致力于通过科技创新和教育服务，推动中国证券市场的健康发展，助力投资者建立理性的投资观念，提升专业知识。</span>
        <span class="us_title2">核心价值观</span>
        <span class="us_text">专业：金融级技术标准，权威可信的服务品质</span>
        <span class="us_text">创新：持续的技术创新，引领行业发展方向</span>
        <span class="us_text">诚信：透明合规的服务理念，用户利益至上</span>
        <span class="us_text">共赢：与用户共同成长，创造长期价值</span>
      </div>

    </div>


  </el-config-provider>
</template>
<script>

import zhCn from "element-plus/lib/locale/lang/zh-cn";


export default {
  components: {},
  data() {
    return {
      locale: zhCn,
    };
  },
  methods: {


  }
};

</script>

<style scoped>
.us_main {
  background-color: #fff;
  width: 100%;
  height: 100%;

}
.us_box{
  padding: 50px 15%;
  padding-top: 50px;
  height: 100%;
  min-height: calc(100vh - 98px - 248px); /* 减去导航栏和页脚的高度 */
}

@media (max-width: 768px) {
  .us_box{
    padding: 30px;
    height: 100%;

  }
}

.us_text {
  display: block;
  font-weight: 400;
  font-size: 14px;
  color: #040404;
  line-height: 24px;

}
.us_title1{
  display: block;
  font-weight: bold;
  font-size: 18px;
  color: #040404;
  line-height: 24px;
  margin-bottom: 10px;
  margin-top: 10px;
}
.us_title2{
  display: block;
  font-weight: bold;
  font-size: 16px;
  color: #040404;
  line-height: 24px;
  margin-bottom: 10px;
  margin-top: 10px;
}




</style>
